import i18n from "i18next";
import PropTypes from "prop-types";
import {useLocation} from "react-router";

const InContextTranslations = ({children, projectName, location}) => {
    if (location) {
        location = new URL(location).search;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        location = useLocation();
    }
    const urlSearchParams = new URLSearchParams(location);

    if (urlSearchParams.get("incontext") === "true") {
        // change to in-context pseudo-language
        i18n.changeLanguage("ach-UG");

        // add global vars
        global._jipt = [];
        global._jipt.push(["project", projectName]);

        // add crowdin script
        const inContextScript = document.getElementById("in-context-editor");
        inContextScript.src = "//cdn.crowdin.com/jipt/jipt.js";
    }

    return children;
};

InContextTranslations.propTypes = {
    projectName: PropTypes.string.isRequired,
};

export default InContextTranslations;
